import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum ArkFoodsTraderJoesPackingSlipLineItemKeys {
  poNumber = 'poNumber',
  sku = 'sku',
  privateLabelOrBrandName = 'privateLabelOrBrandName',
  productDescriptionAndPackSize = 'productDescriptionAndPackSize',
  randomWeight = 'randomWeight',
  unitPackaging = 'unitPackaging',
  lotOrCodeDates = 'lotOrCodeDates',
  caseCountShipped = 'caseCountShipped',
}

export const arkFoodsTraderJoesPackingSlipLineItemSchema = yup.object({
  [ArkFoodsTraderJoesPackingSlipLineItemKeys.poNumber]: yup.string().notRequired(),
  [ArkFoodsTraderJoesPackingSlipLineItemKeys.sku]: yup.string().notRequired(),
  [ArkFoodsTraderJoesPackingSlipLineItemKeys.privateLabelOrBrandName]: yup.string().notRequired(),
  [ArkFoodsTraderJoesPackingSlipLineItemKeys.productDescriptionAndPackSize]: yup
    .string()
    .notRequired(),
  [ArkFoodsTraderJoesPackingSlipLineItemKeys.randomWeight]: yup.string().notRequired(),
  [ArkFoodsTraderJoesPackingSlipLineItemKeys.unitPackaging]: yup.string().notRequired(),
  [ArkFoodsTraderJoesPackingSlipLineItemKeys.lotOrCodeDates]: yup.string().notRequired(),
  [ArkFoodsTraderJoesPackingSlipLineItemKeys.caseCountShipped]: yup.string().notRequired(),
})

export const arkFoodsTraderJoesPackingSlipAddressLineSchema = yup.object({
  line: yup.string().notRequired(),
})

/**
 * Trader Joe's own "Bioterrorism Packing Slip" form (revised 7/13/05).
 *
 * The document title and the vendor name are fixed text on the template, so neither appears here.
 * Ship To phone, receiver signature and receiver date are also absent by design: they are ruled
 * blank lines the receiver fills in by hand at the dock.
 */
export const arkFoodsTraderJoesPackingSlipFileDataSchema = yup.object({
  vendorAddress: yup.array().of(arkFoodsTraderJoesPackingSlipAddressLineSchema).required(),
  vendorPhones: yup.string().notRequired(),
  estDeliveryDate: yup.string().notRequired(),
  poNumber: yup.string().notRequired(),
  trailerOrContainerNumber: yup.string().notRequired(),
  lineItems: yup.array().of(arkFoodsTraderJoesPackingSlipLineItemSchema).required(),
  truckingCompanyName: yup.string().notRequired(),
  truckingCompanyAddress: yup.array().of(arkFoodsTraderJoesPackingSlipAddressLineSchema).required(),
  truckingCompanyPhones: yup.string().notRequired(),
  shipperSignature: yup.string().notRequired(),
  shipperDate: yup.string().notRequired(),
  shipToName: yup.string().notRequired(),
  shipToAddress: yup.array().of(arkFoodsTraderJoesPackingSlipAddressLineSchema).required(),
})

export type ArkFoodsTraderJoesPackingSlipFileData = yup.InferType<
  typeof arkFoodsTraderJoesPackingSlipFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<ArkFoodsTraderJoesPackingSlipFileData>

export const arkFoodsTraderJoesPackingSlipFileMappings: RequiredFileData = {
  vendorAddress: [{ line: 'ae4a6e1d-9aaf-46b1-a0d9-9a6e640c495d' }],
  vendorPhones: '1266f04f-a8b1-4d0b-9a15-aeeef79c6e4f',
  estDeliveryDate: '9a170332-84c9-4eea-8008-c425aeacc54a',
  poNumber: 'ff0b399a-bb19-45de-8bfd-1dde2526d747',
  trailerOrContainerNumber: '4f298893-4de2-4d42-b96a-4645b0fae2c4',
  lineItems: [
    {
      poNumber: '2d4a54aa-bdf8-4acc-85a1-78fe2ae34011',
      sku: 'e559daf1-b20a-4f83-a7f8-8c4cbe9b2d92',
      privateLabelOrBrandName: 'bb60a3fc-5f67-45f6-b841-c5c06fca742b',
      productDescriptionAndPackSize: '4ddbc078-af6a-4d6a-824f-cf9f469d389d',
      randomWeight: '83d74471-ccec-4157-98a5-92cf6a0e0adb',
      unitPackaging: 'dba2fe41-0aee-4152-8ff1-9ca53b7997c2',
      lotOrCodeDates: '1c85710d-d86d-4227-83b9-43b0c8ed4284',
      caseCountShipped: 'aa86ded1-8ab3-412c-9a54-ecf3c723d919',
    },
  ],
  truckingCompanyName: '8bff15ae-5597-4a37-b570-69eadba8dbed',
  truckingCompanyAddress: [{ line: 'b37c59c6-5183-4060-b269-eaba6cf38a80' }],
  truckingCompanyPhones: '7af13883-d3d7-45fc-afeb-5fb18f4ba494',
  shipperSignature: '9aa6ae4a-62ce-4c92-8b47-5749765432a6',
  shipperDate: 'ded00ad7-8f8d-4ed8-a271-8577ae23b065',
  shipToName: 'cf3f8622-e70a-412c-99b6-973785c6971c',
  shipToAddress: [{ line: '91d28bf6-4ebe-4356-94da-fa96aaa2fa49' }],
}
